import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../utils/Constants";

const URL = config.url;

const initialState = {
    data : null,
    isloading: "idle",
    error: null
};


const rolesAndPermissionsSlice = createSlice({
    name: "rolesAndPermissions",
    initialState,
    reducers: {
        setData: (state, action) => {
            state.data = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isloading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setData, setError, setIsLoading } = rolesAndPermissionsSlice.actions;

export default rolesAndPermissionsSlice.reducer;
